import { ChevronDown } from "lucide-react";

import type { StageStatus } from "@/adapters/api";
import { Badge } from "@/components/ui/badge";
import { STAGE_STATUS } from "../../utils/status.ts";

export function StatusBadge({
	status,
	withChevron = false,
}: {
	status: StageStatus;
	withChevron?: boolean;
}) {
	const presentation = STAGE_STATUS[status];
	return (
		<Badge
			variant={presentation.variant}
			className="status-badge"
			data-status={status}
		>
			<span aria-hidden className="status-dot" data-status={status} />
			{presentation.label}
			{withChevron && <ChevronDown className="status-badge__chevron" />}
		</Badge>
	);
}
